import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { from, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ModalService } from '../services';
import { FormService } from '../services/component-services/form.service';
import { DiscardChangesModalComponent } from '../components/modals/discard-changes-modal/discard-changes-modal.component';

@Injectable({
  providedIn: 'root',
})
export class DiscardChangesGuard {
  readonly formService = inject(FormService);
  private readonly modalService = inject(ModalService);

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.formService.anyFormChanges(this.modalService.modalLevel)) {
      return true;
    }

    return from(
      this.modalService.openMedium<DiscardChangesModalComponent>(DiscardChangesModalComponent).modal.result,
    ).pipe(
      tap((discard: boolean) => {
        if (discard) {
          this.formService.resetForms(this.modalService.modalLevel);
        }
      }),
    );
  }
}
